module.exports = __webpack_public_path__ + "img/stu-info-regst-r.3992d916.jpg";